import { axiosClient } from "@lib/services/axios";
import { ENDPOINTS } from "@lib/constants/general";
import { BindingsList } from "@lib/types/binding";

export const getBindings = async (driverId?: string): Promise<BindingsList> => {
  const { data } = await axiosClient.get(ENDPOINTS.BASE_BINDING, {
    params: driverId ? { driver_id: driverId } : undefined,
  });
  return data;
};
